import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchChat, saveChat } from '~actions'; // eslint-disable-line
import { getActionLog } from '~selectors'; // eslint-disable-line
import { getToken } from '~services/utils'; // eslint-disable-line
import styled from 'styled-components';

// Components
import Padder from '../../components/Padder'; // eslint-disable-line
import ChatBox from './ChatBox';
import ActionLog from '../actionlog/actionlog.container';

const propTypes = {
  match: PropTypes.object.isRequired, // Injected by React Router
  fetchChat: PropTypes.func.isRequired,
  actionLog: PropTypes.array.isRequired,
  chat: PropTypes.object,
};

class Chat extends Component {
  state = { isClient: false };

  componentWillMount() {
    const { match } = this.props;
    const chatId = parseInt(match.params.chatId, 10);
    const token = getToken();
    if (token) {
      this.setState({ isClient: true });
    }
    this.props.fetchChat({ id: chatId, token });
  }

  render() {
    return (
      <Container>
        <ActionLog actionLog={this.props.actionLog} />
        <Padder />
        {this.props.chat && this.props.chat.id && (
          <ChatBox isClient={this.state.isClient} {...this.props} />
        )}
      </Container>
    );
  }
}

Chat.propTypes = propTypes;

const Container = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1100px;
  padding: 12px;
  width: 100%;
`;

// This makes state objects available to the component via props!
function mapStateToProps(state) {
  return {
    chat: state.chat,
    actionLog: getActionLog(state, 'chat'),
  };
}

// // This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchChat,
      saveChat,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
